/**
 * Buduje krótkie podsumowanie widocznych terminów programu.
 * Będzie używane przez sticky pasek oraz karty katalogowe.
 */
export function getProgramSummary(terms = []) {
  const visibleTerms = terms.filter(
    term => term?.isHidden !== true
  )
  const prices = visibleTerms
    .map(term => term?.price)
    .filter(price =>
      Number.isFinite(Number(price?.amount))
    )
  const distinctPrices = new Set(
    prices.map(
      price =>
        `${price.currency ?? ''}:${Number(price.amount)}`
    )
  )
  const lowestPrice = prices.reduce(
    (lowest, price) => {
      if (!lowest) return price

      return Number(price.amount) <
        Number(lowest.amount)
        ? price
        : lowest
    },
    null
  )

  return {
    termCount: visibleTerms.length,
    lowestPrice,
    pricesDiffer: distinctPrices.size > 1,
  }
}
